<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >

    <v-layout
      ma-0
      justify-center
      wrap
    >
      <v-flex
        v-if="cliente.catarticoli =='Composito'"
        text-xs-center
        sm12
        xs12
        md12
        lg12>
        <img
          src="https://www.cruing.com/wp-content/uploads/2017/04/composites-1024x1024.png"
          height="30">
        <span class="headline"> {{ $store.state.labels.current_lan.tk_composites }}</span>
        <v-divider/>
      </v-flex>
      <v-flex
        v-if="cliente.catarticoli=='Composito'"
        sm6
        xs12
        md4
        lg3
      >
        <material-stats-card
          :value="cliente.articoli.contatori.milling || 0"
          :title="$store.state.labels.current_lan.tk_milling"
          color="white"
          img="images/Milling.jpg"
          sub-icon="mdi-calendar"
          sub-text=""
          @click="setfamigliacorrente('milling')"
        />
      </v-flex>
      <v-flex
        v-if="cliente.catarticoli=='Composito'"
        sm6
        xs12
        md4
        lg3
      >
        <material-stats-card
          :value="cliente.articoli.contatori.drilling"
          :title="$store.state.labels.current_lan.tk_drilling"
          color="white"
          img="images/Drilling.jpg"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
          @click="setfamigliacorrente('drilling')"
        />
      </v-flex>
      <template v-if="cliente.catarticoli == 'Legno'">
        <v-flex
          text-xs-center
          sm12
          xs12
          md12
          lg12>
          <img
            src="https://www.cruing.com/wp-content/uploads/2017/04/woodworking-1024x1024.png"
            height="30">
          <span class="headline"> {{ $store.state.labels.current_lan.tk_wood }}</span>
          <v-divider/>
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.cutting"
            :title="$store.state.labels.current_lan.tk_cutting"
            color="white"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            img="images/Cutting.jpg"
            @click="setfamigliacorrente('cutting')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.hogging"
            :title="$store.state.labels.current_lan.tk_hogging"
            color="white"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            img="images/Hogging.jpg"
            @click="setfamigliacorrente('hogging')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.nesting"
            :title="$store.state.labels.current_lan.tk_nesting"
            color="white"
            img="images/nesting.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('nesting')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.postforming"
            :title="$store.state.labels.current_lan.tk_postforming"
            color="white"
            img="images/Postforming.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('postforming')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.prouting"
            :title="$store.state.labels.current_lan.tk_prouting"
            color="white"
            img="images/Prouting.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('prouting')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.pcutting"
            :title="$store.state.labels.current_lan.tk_pcutting"
            color="white"
            img="images/Pcutting.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('pcutting')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.parquet"
            :title="$store.state.labels.current_lan.tk_parquet"
            color="white"
            img="images/Parquet.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('parquet')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.sizing"
            :title="$store.state.labels.current_lan.tk_sizing"
            color="white"
            img="images/Sizing.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('sizing')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.boring"
            :title="$store.state.labels.current_lan.tk_boring"
            color="white"
            img="images/Boring.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('boring')"
          />
        </v-flex>
        <v-flex
          sm6
          xs12
          md3
          lg2
        >
          <material-stats-card
            :value="cliente.articoli.contatori.routing"
            :title="$store.state.labels.current_lan.tk_routing"
            color="white"
            img="images/Routing.jpg"
            sub-icon="mdi-calendar"
            sub-text="Last 24 Hours"
            @click="setfamigliacorrente('routing')"
          />
        </v-flex>
      </template>
      <v-flex
        text-xs-center
        sm12
        xs12
        md12
        lg12>
        <img
          src="https://www.cruing.com/wp-content/uploads/2017/04/aerotech.png"
          height="30">
        <span class="headline"> {{ $store.state.labels.current_lan.tk_other }}</span>
        <v-divider/>
      </v-flex>
      <v-flex
        sm6
        xs12
        md4
        lg3
      >
        <material-stats-card
          :value="cliente.articoli.contatori.aertotech"
          :title="$store.state.labels.current_lan.tk_aertotech"
          color="white"
          img="images/Aerotech.jpg"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
          @click="setfamigliacorrente('aertotech')"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md4
        lg3
      >
        <material-stats-card
          :value="cliente.articoli.contatori.altri"
          :title="$store.state.labels.current_lan.tk_others"
          color="white"
          img="images/Others.jpg"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
          @click="setfamigliacorrente('altro')"
        />
      </v-flex>
      <v-flex
        text-xs-center
        sm12
        xs12
        md12
        lg12>
        <span class="headline"> {{ $store.state.labels.current_lan.tk_in_service_now }}</span>
        <v-divider/>
      </v-flex>

      <v-flex
        sm12
        xs12
        md4
        lg3
      >
        <material-stats-card
          :value="cliente.articoli.contatori.ntoolsinservice"
          :title="$store.state.labels.current_lan.tk_ntoolsinservice"
          color="#004876"
          img="images/manute.jpg"
        />
      </v-flex>

      <v-flex
        md12
        lg12
      >
        <material-card
          id="grigliamatricole"
          color="#004876"
          title="Tools"
          text=""
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
          <v-data-table
            :headers="matricole_heads"
            :items="lista_articoli"
            :search="search"
            @click:row="apriarticoloriga"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light  text--darken-3"
                style="color:#004876"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <tr @click="apriarticolo(item.idarticolo)">
                <td>{{ item.idarticolo }}</td>
                <td>{{ item.sezione }}</td>
                <!--<td class="text-xs-right">{{ item[0].articolo }}</td>-->
                <td>{{ item.descrizione }}</td>
                <td><v-icon>mdi-eye</v-icon></td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    APIURL: 'https://us-central1-toolmanagement2-f3d7f.cloudfunctions.net/webApi/api/v1',
    famiglia_corrente: '',
    search: '',
    matricole_heads: [
      {
        sortable: true,
        text: 'id',
        value: 'idarticolo'
      },
      {
        sortable: false,
        text: 'sezione',
        value: 'sezione'
      },
      {
        sortable: false,
        text: 'description',
        value: 'descrizione'
      },
      {
        sortable: false,
        text: '',
        value: 'show'
      }],
    matricole: [
      {
        matricola: '10095',
        articolo: 'PT211',
        data_acquisto: null,
        idcliente: 10005,
        descrizione: 'PT211',
        broken: null
      }
    ]
  }),
  computed: {
    totalecompositi () {
      return this.$store.state.clientecorrente.articoli.contatori.drilling + this.$store.state.clientecorrente.articoli.contatori.milling
    },
    cliente () {
      return this.$store.state.clientecorrente
    },
    lista_articoli_old () {
      if (this.famiglia_corrente !== '') {
        return this.cliente.articoli.items.filter(x => x.sezione === this.famiglia_corrente)
      } else {
        return this.cliente.articoli.items
      }
    },
    lista_articoli () {
      console.log(this.$store.state.articolicliente.data)
      if (this.famiglia_corrente !== '') {
        return Object.values(this.$store.state.articolicliente.data).filter(x => x.sezione === this.famiglia_corrente)
      } else {
        return Object.values(this.$store.state.articolicliente.data)
      }
    }
  },
  mounted () {
    console.log('AAAAA')
  },
  methods: {
    complete (index) {
      this.list[index] = !this.list[index]
    },
    setfamigliacorrente (famiglia) {
      this.famiglia_corrente = famiglia
      this.$vuetify.goTo('#grigliamatricole', {
        duration: 200,
        offset: -5
      })
    },
    apriarticolo (idarticolo) {
      console.log('apro', idarticolo)
      this.$store.dispatch('getArticolo', idarticolo)
    },
    getDescrizione (matricola) {
      var descr = ''
      if (matricola.traduzioni) {
        console.log('matricola:', matricola)
        return matricola.traduzioni.filter(x => x.lingua === 'I')[0].testo
      }
      return descr
    }
  }

}
</script>
